import { useForm } from 'app/hooks/form';
import type { CreateGuidelinesDTO } from 'app/types/user';

import * as yup from 'yup';

export function useGuidelinesForm() {
  const schema: yup.ObjectSchema<CreateGuidelinesDTO> = yup.object({
    acceptConditions: yup.boolean().isTrue().required(),
    acceptGuidelines: yup.boolean().isTrue().required(),
    startingKit: yup.boolean().default(false).required(),
  });

  return useForm<CreateGuidelinesDTO>({ schema });
}
